import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createBlock as _createBlock, renderList as _renderList, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "d-flex align-items-center justify-content-center flex-column vh-100 text-center"
}
const _hoisted_2 = { class: "card w-50" }
const _hoisted_3 = { class: "card-body" }
const _hoisted_4 = { class: "card bg-transparent border-0" }
const _hoisted_5 = { class: "card-body d-flex" }
const _hoisted_6 = ["disabled"]
const _hoisted_7 = {
  key: 1,
  class: "fa fa-spinner fa-spin"
}
const _hoisted_8 = { class: "row vh-100" }
const _hoisted_9 = { class: "col-md-9" }
const _hoisted_10 = { class: "row mt-2" }
const _hoisted_11 = { class: "col" }
const _hoisted_12 = { class: "card h-100" }
const _hoisted_13 = { class: "card-body justify-content-center d-flex flex-column py-5" }
const _hoisted_14 = { class: "d-flex gap-3 w-100" }
const _hoisted_15 = { class: "form-floating flex-fill" }
const _hoisted_16 = {
  key: 0,
  class: "row mt-3"
}
const _hoisted_17 = {
  key: 0,
  class: "col-md-10 mt-3 mx-auto"
}
const _hoisted_18 = { class: "input-group gap-2 mb-4" }
const _hoisted_19 = { class: "form-floating w-25" }
const _hoisted_20 = ["value"]
const _hoisted_21 = ["value"]
const _hoisted_22 = {
  key: 0,
  class: "alert alert-info mb-4"
}
const _hoisted_23 = { class: "m-0" }
const _hoisted_24 = ["disabled"]
const _hoisted_25 = { class: "col-4" }
const _hoisted_26 = { class: "card h-100" }
const _hoisted_27 = { class: "card-body align-items-center justify-content-center d-flex flex-column" }
const _hoisted_28 = { class: "d-flex" }
const _hoisted_29 = { class: "btn btn-primary" }
const _hoisted_30 = {
  key: 1,
  class: "fa fa-spinner fa-spin"
}
const _hoisted_31 = {
  key: 0,
  class: "card mt-2 bg-warning text-white"
}
const _hoisted_32 = { class: "card-body" }
const _hoisted_33 = {
  key: 0,
  class: "m-0"
}
const _hoisted_34 = {
  key: 1,
  class: "m-0"
}
const _hoisted_35 = {
  key: 1,
  class: "card mt-2"
}
const _hoisted_36 = {
  key: 0,
  class: "card-header gap-2 d-flex justify-content-end align-items-center"
}
const _hoisted_37 = { class: "card-body" }
const _hoisted_38 = {
  key: 0,
  class: "list-group list-group-numbered"
}
const _hoisted_39 = { class: "ms-2 me-auto" }
const _hoisted_40 = { class: "fw-bold" }
const _hoisted_41 = { class: "d-flex mt-3 gap-3" }
const _hoisted_42 = { class: "btn btn-outline-secondary" }
const _hoisted_43 = ["onClick"]
const _hoisted_44 = {
  key: 2,
  class: "card bg-transparent border-0"
}
const _hoisted_45 = { class: "card-body d-flex" }
const _hoisted_46 = {
  key: 1,
  class: "fa fa-spinner fa-spin"
}
const _hoisted_47 = { class: "col" }
const _hoisted_48 = { class: "d-flex flex-column gap-2" }
const _hoisted_49 = {
  key: 0,
  class: "card py-4"
}
const _hoisted_50 = { class: "card-body text-center" }
const _hoisted_51 = { class: "mb-3" }
const _hoisted_52 = { class: "d-flex align-items-center justify-content-center gap-3" }
const _hoisted_53 = { class: "w-25" }
const _hoisted_54 = { class: "m-0" }
const _hoisted_55 = { class: "w-25" }
const _hoisted_56 = { class: "m-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_team_member = _resolveComponent("team-member")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_ctx.event)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _cache[11] || (_cache[11] = _createElementVNode("h1", null, [
                _createElementVNode("i", {
                  class: "fas fa-ticket-alt",
                  style: {"font-size":"2em"}
                })
              ], -1)),
              _cache[12] || (_cache[12] = _createElementVNode("h4", { class: "mb-0" }, "Aún no hay eventos disponibles.", -1)),
              _cache[13] || (_cache[13] = _createElementVNode("p", { class: "mt-0" }, "Comienza por agregar el primero", -1)),
              _createElementVNode("button", {
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goNewEvent && _ctx.goNewEvent(...args))),
                class: "btn btn-primary mt-2 me-2"
              }, [...(_cache[10] || (_cache[10] = [
                _createElementVNode("i", { class: "fas fa-plus" }, null, -1),
                _createTextVNode(" Agregar nuevo evento ", -1)
              ]))])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.event)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("h2", null, "Asignar tickets del evento: " + _toDisplayString(_ctx.event.title), 1),
              _createElementVNode("button", {
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.saveChanges && _ctx.saveChanges(...args))),
                class: "btn btn-primary ms-auto",
                disabled: Object.entries(_ctx.ticketsAdded).length == 0
              }, [
                (!_ctx.loading)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _cache[14] || (_cache[14] = _createElementVNode("i", { class: "fas fa-save me-1" }, null, -1)),
                      _cache[15] || (_cache[15] = _createTextVNode(" Guardar cambios ", -1))
                    ], 64))
                  : _createCommentVNode("", true),
                (_ctx.loading)
                  ? (_openBlock(), _createElementBlock("i", _hoisted_7))
                  : _createCommentVNode("", true)
              ], 8, _hoisted_6)
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("form", {
                        onSubmit: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.searchUser && _ctx.searchUser(...args))),
                        class: "d-flex col-md-10 mx-auto"
                      }, [
                        _createElementVNode("div", _hoisted_14, [
                          _createElementVNode("div", _hoisted_15, [
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.user) = $event)),
                              class: "form-control"
                            }, null, 512), [
                              [_vModelText, _ctx.user]
                            ]),
                            _cache[16] || (_cache[16] = _createElementVNode("label", null, "Usuario", -1))
                          ]),
                          _cache[17] || (_cache[17] = _createElementVNode("button", {
                            type: "submit",
                            class: "btn btn-primary align-self-center h-100 px-5"
                          }, [
                            _createElementVNode("i", { class: "fas fa-search" }),
                            _createTextVNode(" Buscar ")
                          ], -1))
                        ])
                      ], 32),
                      (_ctx.selected)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                            (!_ctx.selectedError)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                  (_openBlock(), _createBlock(_component_team_member, {
                                    simple: true,
                                    key: _ctx.selected.usernamePK,
                                    "member-data": _ctx.selected,
                                    maxPointsPerUser: _ctx.selected.nextRankMaxPoints,
                                    "team-side": 'true'
                                  }, null, 8, ["member-data", "maxPointsPerUser"])),
                                  _createElementVNode("div", _hoisted_18, [
                                    _createElementVNode("div", _hoisted_19, [
                                      _withDirectives(_createElementVNode("input", {
                                        class: "form-control",
                                        placeholder: "Cantidad",
                                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.quantity) = $event)),
                                        type: "number"
                                      }, null, 512), [
                                        [_vModelText, _ctx.quantity]
                                      ]),
                                      _cache[18] || (_cache[18] = _createElementVNode("label", { for: "floatingInput" }, "Cantidad", -1))
                                    ]),
                                    _createElementVNode("select", {
                                      class: "form-select rounded",
                                      required: "",
                                      value: _ctx.ticketOptionValue,
                                      onChange: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.setOptionTicket && _ctx.setOptionTicket(...args)))
                                    }, [
                                      _cache[19] || (_cache[19] = _createElementVNode("option", {
                                        value: "",
                                        selected: "",
                                        disabled: ""
                                      }, "Selecciona el tipo de boleto", -1)),
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.event.ticket_options, (option) => {
                                        return (_openBlock(), _createElementBlock("option", {
                                          key: option.id,
                                          value: option.id
                                        }, _toDisplayString(option.name), 9, _hoisted_21))
                                      }), 128))
                                    ], 40, _hoisted_20)
                                  ]),
                                  (_ctx.quantity && _ctx.user && _ctx.ticketOption)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                                        _createElementVNode("p", _hoisted_23, [
                                          _cache[23] || (_cache[23] = _createElementVNode("i", { class: "fas fa-question-circle me-2" }, null, -1)),
                                          _cache[24] || (_cache[24] = _createTextVNode(" Se asignará ", -1)),
                                          _createElementVNode("strong", null, _toDisplayString(_ctx.quantity), 1),
                                          _createTextVNode(" " + _toDisplayString(_ctx.ticketOption?.pack ? "paquete(s)" : "boleto(s)") + " de tipo ", 1),
                                          _createElementVNode("strong", null, _toDisplayString(_ctx.ticketOption?.name), 1),
                                          _cache[25] || (_cache[25] = _createTextVNode(" a ", -1)),
                                          _createElementVNode("strong", null, _toDisplayString(_ctx.user), 1),
                                          _cache[26] || (_cache[26] = _createTextVNode(". ", -1)),
                                          (_ctx.ticketOption?.pack)
                                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                _cache[20] || (_cache[20] = _createTextVNode(" (", -1)),
                                                _createElementVNode("strong", null, _toDisplayString(_ctx.ticketOption?.pack?.quantity * _ctx.quantity), 1),
                                                _cache[21] || (_cache[21] = _createTextVNode(" boletos tipo ", -1)),
                                                _createElementVNode("strong", null, _toDisplayString(_ctx.ticketOption?.pack?.option.name), 1),
                                                _cache[22] || (_cache[22] = _createTextVNode(") ", -1))
                                              ], 64))
                                            : _createCommentVNode("", true)
                                        ])
                                      ]))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("button", {
                                    class: "btn btn-primary align-self-center w-100 py-3",
                                    disabled: 
                        _ctx.event.ticket_options?.length == 0 ||
                        !_ctx.quantity ||
                        !_ctx.user ||
                        !_ctx.ticketOption
                      ,
                                    onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.addTickets && _ctx.addTickets(...args)))
                                  }, [...(_cache[27] || (_cache[27] = [
                                    _createElementVNode("i", { class: "fas fa-plus" }, null, -1),
                                    _createTextVNode(" Agregar tickets ", -1)
                                  ]))], 8, _hoisted_24)
                                ]))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_25, [
                  _createElementVNode("div", _hoisted_26, [
                    _createElementVNode("div", _hoisted_27, [
                      _createElementVNode("div", _hoisted_28, [
                        _createElementVNode("button", {
                          ref: "popover",
                          type: "button",
                          class: "btn link-info",
                          onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.btnPopover && _ctx.btnPopover(...args))),
                          "data-bs-placement": "left"
                        }, [...(_cache[28] || (_cache[28] = [
                          _createElementVNode("i", { class: "fas fa-question-circle" }, null, -1)
                        ]))], 512),
                        _createElementVNode("label", _hoisted_29, [
                          _createElementVNode("input", {
                            type: "file",
                            style: {"visibility":"hidden","display":"none"},
                            accept: ".csv",
                            onChange: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.parseCsv && _ctx.parseCsv(...args)))
                          }, null, 32),
                          (!_ctx.uploadingCSV)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _cache[29] || (_cache[29] = _createElementVNode("i", { class: "fas fa-file-csv" }, null, -1)),
                                _cache[30] || (_cache[30] = _createTextVNode(" Subir un CSV ", -1))
                              ], 64))
                            : _createCommentVNode("", true),
                          (_ctx.uploadingCSV)
                            ? (_openBlock(), _createElementBlock("i", _hoisted_30))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _cache[31] || (_cache[31] = _createElementVNode("p", { class: "mt-2 mb-0" }, [
                        _createTextVNode("Descarga el ejemplo "),
                        _createElementVNode("a", {
                          target: "_blank",
                          href: "/example.csv"
                        }, "aquí")
                      ], -1))
                    ])
                  ])
                ])
              ]),
              (_ctx.usersNotAdded.length > 0 || _ctx.ticketsNotAdded.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                    _createElementVNode("div", _hoisted_32, [
                      (_ctx.usersNotAdded.length > 0)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_33, [
                            _cache[32] || (_cache[32] = _createTextVNode(" Usuarios no agregados: ", -1)),
                            _createElementVNode("strong", null, _toDisplayString(_ctx.usersNotAdded.join(", ")), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.ticketsNotAdded.length > 0)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_34, [
                            _cache[33] || (_cache[33] = _createTextVNode(" Tipos no agregados: ", -1)),
                            _createElementVNode("strong", null, _toDisplayString(_ctx.ticketsNotAdded.join(", ")), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (Object.entries(_ctx.ticketsAdded).length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                    (Object.entries(_ctx.ticketsAdded).length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                          _cache[34] || (_cache[34] = _createTextVNode(" Se asignarán: ", -1)),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ticketTypes, ([type, quantity]) => {
                            return (_openBlock(), _createElementBlock("div", {
                              class: "btn-group",
                              key: type[0]
                            }, [
                              _createElementVNode("button", {
                                disabled: "",
                                class: _normalizeClass(["btn btn-sm opacity-100", 
                  type == 'Total'
                    ? 'btn-outline-primary'
                    : 'btn-outline-secondary'
                ])
                              }, [
                                _createElementVNode("strong", null, _toDisplayString(type), 1)
                              ], 2),
                              _createElementVNode("button", {
                                disabled: "",
                                class: _normalizeClass(["btn btn-sm opacity-100", type == 'Total' ? 'btn-primary' : 'btn-secondary'])
                              }, _toDisplayString(quantity), 3)
                            ]))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_37, [
                      (Object.entries(_ctx.ticketsAdded).length > 0)
                        ? (_openBlock(), _createElementBlock("ul", _hoisted_38, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.entries(_ctx.ticketsAdded), ([user, options]) => {
                              return (_openBlock(), _createElementBlock("li", {
                                class: "list-group-item py-4 d-flex justify-content-between align-items-start",
                                key: user
                              }, [
                                _createElementVNode("div", _hoisted_39, [
                                  _createElementVNode("div", _hoisted_40, _toDisplayString(user), 1),
                                  _createElementVNode("div", _hoisted_41, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((Object.values(options) as any), ({ quantity, option }) => {
                                      return (_openBlock(), _createElementBlock("div", {
                                        class: "btn-group",
                                        role: "group",
                                        "aria-label": "Basic mixed styles example",
                                        key: option?.id
                                      }, [
                                        _createElementVNode("button", _hoisted_42, [
                                          _createElementVNode("strong", null, _toDisplayString(option.name), 1),
                                          _createTextVNode(" : " + _toDisplayString(quantity) + " " + _toDisplayString(option.pack ? "paquete(s)" : "boleto(s)"), 1)
                                        ]),
                                        _createElementVNode("button", {
                                          class: "btn btn-secondary",
                                          onClick: () => _ctx.removeItem(user, option.id)
                                        }, [...(_cache[35] || (_cache[35] = [
                                          _createElementVNode("i", { class: "fas fa-times" }, null, -1)
                                        ]))], 8, _hoisted_43)
                                      ]))
                                    }), 128))
                                  ])
                                ])
                              ]))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (Object.entries(_ctx.ticketsAdded).length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                    _createElementVNode("div", _hoisted_45, [
                      _createElementVNode("button", {
                        class: "btn btn-primary ms-auto",
                        onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.saveChanges && _ctx.saveChanges(...args)))
                      }, [
                        (!_ctx.loading)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _cache[36] || (_cache[36] = _createElementVNode("i", { class: "fas fa-save me-1" }, null, -1)),
                              _cache[37] || (_cache[37] = _createTextVNode(" Guardar cambios ", -1))
                            ], 64))
                          : _createCommentVNode("", true),
                        (_ctx.loading)
                          ? (_openBlock(), _createElementBlock("i", _hoisted_46))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_47, [
              _cache[40] || (_cache[40] = _createElementVNode("h3", { class: "ps-2" }, "Asignados", -1)),
              _cache[41] || (_cache[41] = _createElementVNode("hr", null, null, -1)),
              _createElementVNode("div", _hoisted_48, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.event.ticket_options, (ticket) => {
                  return (_openBlock(), _createElementBlock(_Fragment, {
                    key: ticket.id
                  }, [
                    (ticket.pack === null)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                          _createElementVNode("div", _hoisted_50, [
                            _createElementVNode("h6", _hoisted_51, _toDisplayString(ticket.name), 1),
                            _createElementVNode("div", _hoisted_52, [
                              _createElementVNode("div", _hoisted_53, [
                                _createElementVNode("h2", _hoisted_54, _toDisplayString(_ctx.ticketAnalytics[ticket.id]?.total ?? 0), 1),
                                _cache[38] || (_cache[38] = _createElementVNode("p", { class: "m-0" }, "Total", -1))
                              ]),
                              _createElementVNode("div", _hoisted_55, [
                                _createElementVNode("h2", _hoisted_56, _toDisplayString(_ctx.ticketAnalytics[ticket.id]?.checkIn ?? 0), 1),
                                _cache[39] || (_cache[39] = _createElementVNode("p", { class: "m-0" }, "Check In", -1))
                              ])
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ], 64))
                }), 128))
              ])
            ])
          ])
        ], 64))
      : _createCommentVNode("", true)
  ], 64))
}